import React from 'react';
import { 
    Table, TableBody, TableCell, TableContainer, TableHead, 
    TableRow, Button, IconButton, Typography, Paper, Box
} from '@mui/material';
import { 
    FaPlus, FaEdit, FaWrench, FaArrowUp, FaArrowDown 
} from 'react-icons/fa';

const ContactTopicManagement = ({ 
    topics, 
    onAdd, 
    onEdit,
    onMove 
}) => {
    return (
        <Paper 
            elevation={0} 
            sx={{ 
                mb: 4, 
                borderRadius: '12px', 
                overflow: 'hidden',
                bgcolor: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(0,0,0,0.05)'
            }}
        >
            <Box sx={{ 
                p: 2, 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                borderBottom: '1px solid rgba(0,0,0,0.05)',
                bgcolor: 'rgba(0,0,0,0.01)'
            }}>
                <Typography variant="h6" color="primary" sx={{ fontWeight: 500 }}>Kontakt-Themen</Typography>
                <Button 
                    variant="contained" 
                    size="small" 
                    startIcon={<FaPlus />} 
                    onClick={onAdd}
                    sx={{ borderRadius: '8px', textTransform: 'none' }}
                >
                    Neu
                </Button>
            </Box>
            <Box sx={{ p: 0 }}>
                <TableContainer>
                    <Table size="small">
                        <TableHead sx={{ bgcolor: 'rgba(0,0,0,0.02)' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', color: 'text.secondary', py: 1.5 }}>THEMA</TableCell>
                                <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', color: 'text.secondary', display: { xs: 'none', md: 'table-cell' } }}>E-MAIL EMPFÄNGER</TableCell>
                                <TableCell align="center" sx={{ width: '1%', fontWeight: 600, fontSize: '0.75rem', color: 'text.secondary' }}><FaWrench /></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {topics.map((t, idx) => (
                                <TableRow 
                                    key={t._id} 
                                    hover
                                    sx={{ 
                                        '&:hover': { bgcolor: 'rgba(0,0,0,0.02) !important' },
                                        transition: 'background-color 0.2s'
                                    }}
                                >
                                    <TableCell sx={{ py: 1.5 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                <IconButton 
                                                    size="small" 
                                                    disabled={idx === 0} 
                                                    onClick={() => onMove(idx, -1)}
                                                    sx={{ p: 0.2, color: 'text.secondary' }}
                                                >
                                                    <FaArrowUp fontSize="0.7rem" />
                                                </IconButton>
                                                <IconButton 
                                                    size="small" 
                                                    disabled={idx === topics.length - 1} 
                                                    onClick={() => onMove(idx, 1)}
                                                    sx={{ p: 0.2, color: 'text.secondary' }}
                                                >
                                                    <FaArrowDown fontSize="0.7rem" />
                                                </IconButton>
                                            </Box>
                                            <Typography variant="body2" sx={{ fontSize: '0.85rem', fontWeight: 500 }}>{t.label}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                                        <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary', fontFamily: 'monospace' }}>
                                            {t.recipientEmail}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <IconButton size="small" color="primary" onClick={() => onEdit(t)} sx={{ bgcolor: 'rgba(211, 47, 47, 0.05)', '&:hover': { bgcolor: 'primary.main', color: 'white' } }}>
                                            <FaEdit fontSize="0.85rem" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Paper>
    );
};

export default ContactTopicManagement;
